/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  createTranslation(cannedResponseId, translationObj) {
    return axios.post(`${this.url}/${cannedResponseId}/translations`, translationObj);
  }

  getTranslations(cannedResponseId) {
    return axios.get(`${this.url}/${cannedResponseId}/translations`);
  }

  updateTranslation(cannedResponseId, translationId, translationObj) {
    return axios.put(`${this.url}/${cannedResponseId}/translations/${translationId}`, translationObj);
  }

  importCannedResponses(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  exportCannedResponses() {
    return axios.post(`${this.url}/export`, {}, {
      responseType: 'blob',
    });
  }

  getTags() {
    return axios.get(`${this.url}/tags`);
  }

  deleteAll() {
    return axios.delete(`${this.url}/destroy_all`);
  }
}

export default new CannedResponse();
